<template>
  <td
    class="boss-center"
    data-test="message-td"
    :class="{ 'notice-background': !isMessageReplied }"
  >
    <component
      :is="componentTag"
      data-test="message-link"
      v-bind="additionalProps"
      v-on="additionalListeners"
    >
      <span
        v-if="isMessageReserved"
        data-test="reserved"
      >予約中<br></span>
      <span
        v-if="isMessageReplied"
        data-test="replied"
      >返信済み<br></span>
      <span
        v-else
        data-test="no-replied"
        class="boss-notice-text"
      >未返信<br></span>
      <div class="boss-layout boss-layout-vertical boss-layout-gap-small">
        <div
          v-if="receivedMessageCount"
          data-test="icon-wrap"
        >
          <img
            v-if="!isMessageRead"
            data-test="close-icon"
            src="@/assets/images/dm-close.svg"
          >
          <img
            v-else-if="isMessageRead && isMessageReplied"
            data-test="open-icon-inactive"
            src="@/assets/images/dm-open-gray.svg"
          >
          <img
            v-else-if="isMessageRead && !isMessageReplied"
            data-test="open-icon-active"
            src="@/assets/images/dm-open-red.svg"
          >
        </div>
        <span data-test="received-count">受信数({{ receivedMessageCount }})</span>
        <span data-test="latest-message">{{ latestMessage }}</span>
      </div>
    </component>
  </td>
</template>

<script>
import { createDate } from '@/lib/dateUtils.js'
import _ from 'lodash'

export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    entryId: {
      type: Number,
      required: false,
      default: null
    }
  },
  computed: {
    // 詳細画面への画面遷移ありかどうか
    canGoToApplicantDetail () {
      return !!this.entryId
    },
    isMessageReserved () {
      return _.get(this.message, 'isReserved', false)
    },
    isMessageReplied () {
      return _.get(this.message, 'isReplied', false)
    },
    isMessageRead () {
      return _.get(this.message, 'isRead', false)
    },
    receivedMessageCount () {
      return _.get(this.message, 'receivedCount', 0)
    },
    latestMessage () {
      return createDate(_.get(this.message, 'sendReceiveDateTime'))?.format('MM/DD')
    },
    componentTag () {
      return this.canGoToApplicantDetail ? 'a' : 'span'
    },
    additionalProps () {
      return this.canGoToApplicantDetail ? {
        href: '#',
        class: 'boss-table-4-link'
      } : {}
    },
    additionalListeners () {
      return this.canGoToApplicantDetail ? {
        click: this.goToApplicantDetail
      } : {}
    }
  },
  methods: {
    goToApplicantDetail (event) {
      event.preventDefault()
      // 画面遷移
      this.$router.push({ name: 'applicantDetail', params: { entryId: this.entryId, tabKey: 'message' } })
    }
  }
}
</script>
